import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import OptimallesListPage from "../components/OptimallesListPage";
import {bindActionCreators} from "redux";
import {
    fetchPromotedOptimalles,
    fetchOptimalles,
    setSelectedTheme,
    setSelectedHike,
    setDateRange
} from "../../data/actions/optimalle";
import {isEmpty} from "lodash";

class OptimallesListPageContainer extends Component {
    static propTypes = {
        optimalles: PropTypes.array,
        isLoading: PropTypes.bool,
    };

    constructor(props, context) {
        super(props, context);

        this.handleScroll = this.handleScroll.bind(this);
    }

    componentDidMount() {
        this.props.fetchPromotedOptimalles()
        const {theme, hike, queryParams } = this.props.params;
        if(!isEmpty(theme) && theme != 'itineraires'){
            this.props.setSelectedTheme(theme)
        }
        if(!isEmpty(hike)){
            this.props.setSelectedHike(hike)
        }
        if(!isEmpty(queryParams.from)  && !isEmpty(queryParams.to)){
            this.props.setDateRange(queryParams)
        }
        this.props.fetchOptimalles().then(() => this.enableScrollHandler())
    }

    loadMore() {
        if (this.props.isLoading) {
            return;
        }

        this.disableScrollHandler();
        this.props.fetchOptimalles()
    }

    handleScroll() {
        const { isLoading, reachedEnd } = this.props;

        if (isLoading || reachedEnd) {
            return;
        }

        const { scrollHeight, clientHeight } = document.documentElement;
        const scrollTop = document.body.scrollTop || document.documentElement.scrollTop;
        const trigger = scrollHeight - (scrollTop + clientHeight) < 500;

        if (trigger) {
            this.props.fetchOptimalles()
        }
    }

    enableScrollHandler() {
        window.addEventListener('scroll', this.handleScroll);
    }

    disableScrollHandler() {
        window.removeEventListener('scroll', this.handleScroll);
    }

    render() {
        const {optimalles, isLoading, promoted, filtersEmpty, reachedEnd} = this.props;

        return (
            <OptimallesListPage
                promoted={promoted}
                optimalles={optimalles}
                isLoading={isLoading}
                filtersEmpty={filtersEmpty}
                reachedEnd={reachedEnd}
            />
        );
    }
}

export default connect(
    state => ({
        optimalles: state.optimalles,
        promoted: state.promoted,
        isLoading: state.isFetching,
        filtersEmpty: isEmpty(state.filters.hike) && isEmpty(state.filters.theme),
        reachedEnd: state.reachedEnd
    }),
    dispatch => bindActionCreators({ fetchPromotedOptimalles, setSelectedHike, setSelectedTheme, fetchOptimalles, setDateRange }, dispatch)
)(OptimallesListPageContainer);
